'use strict';

// 核心
import React from 'react';


//
import Component from '../core/component';
import Enhance from '../core/enhance';
import Validate from '../core/validate'
// 工具

import form2js from '../libs/form2js'
import {request, empty, http, pick} from '../libs/tools'
//
import Http from '../common/http'
import debug from 'debug';

const log = debug('mobile.form');

let locale = {
    validate_idCard: "身份证号错误",
    validate_required: '必填项不能为空',
    validate_contains: '{name} need contains {args}',
    validate_equals: '{name} need match {args}',
    validate_different: '{name} need not match {args}',
    validate_after: '{name} need a date that\'s after the {args} (defaults to now)',
    validate_alpha: '{name} need contains only letters (a-z,A-Z)',
    validate_alphaDash: '必须由字母下划线 (a-zA-Z_)',
    validate_alphaNumeric: '必须由字母数字组成 (a-zA-Z0-9)',
    validate_alphaNumericDash: '必须由字母数字下划线组成 (a-z,A-Z,0-9,_)',
    validate_ascii: '{name} need contains ASCII chars only',
    validate_base64: '{name} need a valid base64 encoded',
    validate_before: '{name} need a date that\'s before the {args} (defaults to now)',
    validate_byteLength: '{name} need length (in bytes) falls in {args}',
    validate_creditcard: '{name} need a valid credit card',
    validate_currency: '{name} need a valid currency amount',
    validate_date: '{name} need a date',
    validate_decimal: '{name} need a decimal number',
    validate_divisibleBy: '{name} need a number that\'s divisible by {args}',
    validate_email: '{name} need an email',
    validate_fqdn: '{name} need a fully qualified domain name',
    validate_float: '{name} need a float in {args}',
    validate_fullWidth: '{name} need contains any full-width chars',
    validate_halfWidth: '{name} need contains any half-width chars',
    validate_hexColor: '{name} need a hexadecimal color',
    validate_hex: '{name} need a hexadecimal number',
    validate_ip: '{name} need an IP (version 4 or 6)',
    validate_ip4: '{name} need an IP (version 4)',
    validate_ip6: '{name} need an IP (version 6)',
    validate_isbn: '{name} need an ISBN (version 10 or 13)',
    validate_isin: '{name} need an ISIN (stock/security identifier)',
    validate_iso8601: '{name} need a valid ISO 8601 date',
    validate_in: '{name} need in an array of {args}',
    validate_notIn: '{name} need not in an array of {args}',
    validate_int: '{name} need an integer',
    validate_min: '{name} need an integer greater than {args}',
    validate_max: '{name} need an integer less than {args}',
    validate_length: '长度必须是 {args} 位',
    validate_minLength: '{name} need length is max than {args}',
    validate_maxLength: '{name} need length is min than {args}',
    validate_lowercase: '{name} need is lowercase',
    validate_mobile: '手机号格式错误',
    validate_mongoId: '{name} need is a valid hex-encoded representation of a MongoDB ObjectId',
    validate_multibyte: '{name} need contains one or more multibyte chars',
    validate_url: '{name} need an URL',
    validate_uppercase: '{name} need uppercase',
    validate_variableWidth: '{name} need contains a mixture of full and half-width chars',
    validate_order: '{name} need a valid sql order string',
    validate_field: '{name} need a valid sql field string',
    validate_image: '{name} need a valid image file',
    validate_startWith: '{name} need start with {args}',
    validate_endWidth: '{name} need end with {args}',
    validate_string: '{name} need a string',
    validate_array: '{name} need an array',
    validate_boolean: '{name} need a boolean',
    validate_object: '{name} need an object'
}

/**
 *
 */
class Form extends Component {
    state = {
        fromData: {},
    };

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
    }

    /**
     *
     * @return {*}
     */
    render() {
        return (
            <form
                ref="form"
                {...this.props}
                onSubmit={(e) => {
                    this.handlerSubmit();
                    e.stopPropagation();
                    e.preventDefault();
                    return false;
                }}
            >
                <Http ref="http"/>
                {this.props.children}
            </form>
        );
    }


    /**
     * 提交数据
     * @param e
     * @return {boolean}
     */
    handlerSubmit = async (e) => {
        try {
            let form = this.refs['form'];
            this.state.fromData = form2js(form);
            let valid = true;
            if (!empty(this.props.rules)) {
                try {
                    valid = Validate(this.props.rules, this.state.fromData, locale);
                } catch (ex) {
                    console.error(ex);
                }
            }

            if (valid === true) {

                if (!this.props.onSubmit || (await this.props.onSubmit(this.state.fromData))) {
                    this.refs.http.send(form.action, this.state.fromData, this.props.options)
                        .success(this.handlerSuccess)
                        .error(this.handlerError)
                }


            } else {
                if (this.props.fieldMaping) {
                    let newMsg = {};
                    for (let name in valid) {
                        newMsg[this.props.fieldMaping[name] || name] = valid[name];
                    }
                    valid = newMsg;
                }

                log(valid);
                if (this.props.onErrorMsg) {
                    this.props.onErrorMsg(valid);
                } else {
                    let msgs = [];
                    for (let i in valid) {
                        msgs.push(`${i} : ${valid[i]}`)
                    }
                    window.alert(msgs.join("<br/>"));
                    // window.alert(msgs.map((v) => {
                    //     return <p>{v}</p>
                    // }));
                }

            }
        } catch (ex) {
            console.error(ex)
        } finally {
        }
    }


    /**
     *
     * @param data
     * @private
     */
    handlerSuccess = (data) => {
        this.props.onSuccess && this.props.onSuccess(data)
    }

    /**
     *
     * @param data
     * @private
     */
    handlerError = (data) => {
        this.props.onError && this.props.onError(data)
    }

    /**
     *
     * @param data
     * @private
     */
    _handlerComplete = (data) => {
        this._emit("Loading", false);
        this.props.onComplete && this.props.onComplete(data)
    }


    getFormData(rules) {
        return this._getFormData(rules);
    }


    /**
     *
     * @param rules
     * @returns {*}
     * @private
     */
    _getFormData = (rules) => {
        let _rules = rules || this.props.rules;

        let form = this.refs['form'];
        this.state.fromData = form2js(form);
        let valid = true;
        if (!empty(_rules)) {
            try {
                valid = Validate(_rules, this.state.fromData, locale);
            } catch (ex) {
                console.error(ex);
            }
        }

        if (valid === true) {
            return this.state.fromData;
        } else {
            if (this.props.fieldMaping) {
                var newMsg = {};
                for (var name in valid) {
                    newMsg[this.props.fieldMaping[name] || name] = valid[name];
                }
                valid = newMsg;
            }
            this.props.onErrorMsg && this.props.onErrorMsg(valid);
            return false;
        }

    }
}

Form.displayName = "Form"
Form.defaultProps = {}
export default Form
